import React from 'react'
import { TablePlugin } from '../../../../plugins/components/TablePlugin'
import { useGetPathologicalDiseasesFeaturesQuery } from '../../../../services/rtk-query/clinicalApi'

export const Lista = ({ columns }) => {
  const { data, isFetching } = useGetPathologicalDiseasesFeaturesQuery()
  return (
    <>
      <TablePlugin data={data ?? []} columns={columns} isFetching={isFetching} />
    </>
  )
}
